__turbopack_context__.v({
  "actions": "PortalReviewComposer-module__90-7ja__actions",
  "bodyInput": "PortalReviewComposer-module__90-7ja__bodyInput",
  "cancel": "PortalReviewComposer-module__90-7ja__cancel",
  "composer": "PortalReviewComposer-module__90-7ja__composer",
  "enter": "PortalReviewComposer-module__90-7ja__enter",
  "footer": "PortalReviewComposer-module__90-7ja__footer",
  "heading": "PortalReviewComposer-module__90-7ja__heading",
  "ratingField": "PortalReviewComposer-module__90-7ja__ratingField",
  "ratingOption": "PortalReviewComposer-module__90-7ja__ratingOption",
  "ratingOptions": "PortalReviewComposer-module__90-7ja__ratingOptions",
  "titleInput": "PortalReviewComposer-module__90-7ja__titleInput",
  "titleToggle": "PortalReviewComposer-module__90-7ja__titleToggle",
  "topline": "PortalReviewComposer-module__90-7ja__topline",
  "visuallyHidden": "PortalReviewComposer-module__90-7ja__visuallyHidden",
});
